﻿import $ from 'jquery';

class ComponentFileInputItem {
    constructor(el, i) {
        this.render(el, i);
    }

    render(el, i) {
        this.el = $(el)
        var label = this.el.next().find('[data-ref="label-text"]')
        var labelVal = label.text;
        this.el.on('focus', function () { el.classList.add('has-focus'); });
        this.el.on('blur', function () { el.classList.remove('has-focus'); });
        this.el.on('change', function (e) {
            var fileName = '';

            if (this.files && this.files.length > 1) {
                fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
            } else {
                fileName = e.target.value.split('\\').pop();
            }

            if (fileName) {
                label.text(fileName);
                label.parents('.c-button').addClass('has-files');
            } else {
                label.text(labelVal);
                label.parents('.c-button').removeClass('has-files');
            }
        });
    }
}


class ComponentFileInput {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {
        new ComponentFileInputItem(el, index);
    }
}

export default ComponentFileInput;
